import type { QueryClient } from "@tanstack/react-query";
import { normalizeId } from "utils";
import { budgetKeys } from "./budget.keys";

/**
 * Invalidate project-scoped budget caches so breakdown, fringes, actuals,
 * versions, templates, and tax-incentive recommendations all refresh together.
 */
export const invalidateBudgetQueries = async (
  queryClient: QueryClient,
  projectId: string | number,
  documentId: string | number
): Promise<void> => {
  const pid = normalizeId(projectId);
  const did = normalizeId(documentId);

  await Promise.all([
    queryClient.invalidateQueries({ queryKey: budgetKeys.summary(pid, did) }),
    queryClient.invalidateQueries({ queryKey: budgetKeys.versions(pid, did) }),
    queryClient.invalidateQueries({ queryKey: budgetKeys.templates(pid, did) }),
    queryClient.invalidateQueries({
      queryKey: [...budgetKeys.all, "tax-incentive-recommendations", pid, did],
    }),
  ]);
};
